/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1BadgeIcon16Light } from './People1BadgeIcon16Light';
import { People1BadgeIcon16Regular } from './People1BadgeIcon16Regular';
import { People1BadgeIcon16Solid } from './People1BadgeIcon16Solid';
import { People1BadgeIcon20Light } from './People1BadgeIcon20Light';
import { People1BadgeIcon20Regular } from './People1BadgeIcon20Regular';
import { People1BadgeIcon20Solid } from './People1BadgeIcon20Solid';
import { People1BadgeIcon24Regular } from './People1BadgeIcon24Regular';
import { People1BadgeIcon24Solid } from './People1BadgeIcon24Solid';
import { People1BadgeIcon32Regular } from './People1BadgeIcon32Regular';
import { People1BadgeIcon64Regular } from './People1BadgeIcon64Regular';
var sizes = {
    16: {
        light: People1BadgeIcon16Light,
        regular: People1BadgeIcon16Regular,
        solid: People1BadgeIcon16Solid,
    },
    20: {
        light: People1BadgeIcon20Light,
        regular: People1BadgeIcon20Regular,
        solid: People1BadgeIcon20Solid,
    },
    24: {
        regular: People1BadgeIcon24Regular,
        solid: People1BadgeIcon24Solid,
    },
    32: {
        regular: People1BadgeIcon32Regular,
    },
    64: {
        regular: People1BadgeIcon64Regular,
    },
};
export var People1BadgeIcon = forwardRef('People1BadgeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
